import React from 'react';
// import "./format3.css"

const Format3 = ({ modifyForm = {} }) => {
  const defaultColumns = [
    { name: "Product Description", check: true },
    { name: "No. of Article", check: true },
    { name: "KOT", check: true },
    { name: "Weight", check: true },
    { name: "Sales Value", check: true }
  ];

  // Sample data for the table rows
  const sampleData = [
    {
      "Product Description": "Product 1",
      "No. of Article": "10",
      "KOT": "KOT001",
      "Weight": "100kg",
      "Sales Value": "₹1,000"
    },
    {
      "Product Description": "Product 2",
      "No. of Article": "5",
      "KOT": "KOT002",
      "Weight": "50kg",
      "Sales Value": "₹500"
    }
  ];

  // Function to flatten columns structure
  const getVisibleColumns = (columns) => {
    let result = [];
    
    columns.forEach(col => {
      // If column has children and parent is selected (check: true)
      if (col.select && col.select.length > 0 && col.check) {
        // Add children that are selected (check: true)
        col.select.forEach(child => {
          if (child.check) {
            result.push(child);
          }
        });
      } 
      // If column doesn't have children and is selected (check: true)
      else if (!col.select && col.check) {
        result.push(col);
      }
    });
    
    return result;
  };

  // Merge with modifyForm prop if provided
  const columns = modifyForm?.lr_table?.length > 0 ? modifyForm.lr_table : defaultColumns;

  // Get only visible columns (handling parent-child relationship)
  const visibleColumns = getVisibleColumns(columns);

  // Calculate column widths dynamically
  const calculateColumnWidth = () => {
    const mainContentWidth = 382; // Approximate width of the main content area
    const columnCount = visibleColumns.length;
    const baseWidth = mainContentWidth / columnCount;
    
    // Return widths for up to 5 columns, adjust as needed
    if (columnCount <= 3) return '120px';
    if (columnCount === 4) return '90px';
    return '70px'; // For 5 or more columns
  };

  return (
    <>
    <style>
      {`
      .invoice-box {
            font-size: 12px;
            line-height: 16px;
            font-family: 'Roboto', sans-serif;
            color: #000;
            padding: 0px;
        }

        .border_box {
            border: 1px solid #cccc;
        }

        .invoice-box table {
            width: 100%;
            text-align: left;
            border-collapse: collapse;
        }

        .top_heading p {
            margin-top: 0px;
            margin-bottom: 2px;
            font-size: 11px;
            font-weight: 400;
            line-height: normal;
        }

        .top_heading .h1 {
            font-size: 21.6px !important;
            line-height: normal;
            margin-bottom: 3px;
            display: block;
            font-weight: bold;
        }

        .invoice-box table td {
            vertical-align: top;
        }

        .top_heading {
            padding: 5.5px 0 5.5px;
            text-align: center;
        }

        table.table_right thead td {
            border-bottom: 1px solid #ccc;
            font-size: 10px;
            line-height: normal;
            padding: 6px 10px;
            border-top: none;
            vertical-align: middle;
        }

        table.table_right thead td:nth-child(1) {
            /* width: 28%; */
            width: 200px;
        }

        table.table_right thead td:nth-child(2),
        table.table_right thead td:nth-child(3),
        table.table_right thead td:nth-child(4) {
            /* width: 9%; */
            text-align: center;
        }

        table.table_right tbody td {
            font-size: 10px;
            line-height: normal;
            padding: 6px 10px;
            border-top: none;
            vertical-align: top;
        }

        table.table_right tbody td:nth-child(2),
        table.table_right tbody td:nth-child(3),
        table.table_right tbody td:nth-child(4) {
            text-align: center;
        }

        .table_right td {
            padding: 2px 10px;
        }


        table.table_right thead td .__vrLine {
            content: "";
            width: 1px;
            position: absolute;
            height: 100%;
            top: 0;
            background: #ccc;
            transform: translateX(10px);
            -webkit-print-color-adjust: exact;
        }

        .table_right tfoot td {
            vertical-align: middle;
        }

        .sheet.padding-2mm {
            padding: 2mm;
            background: white;
            page-break-after: always;
        }

        .sheet.padding-2mm:last-child {
            page-break-after: auto;
        }

        .sheet-content {
            transform-origin: top left;
            transition: transform 0.2s ease;
            width: 210mm;
            margin: 0 auto;
        }

        @media (max-width: 280px) {
            .sheet-content {
                transform: scale(calc(17% * 2)) !important;
                transform-origin: 5px 0px;
            }
            html {
                overflow: hidden;
            }
        }

        @media (min-width: 281px) and (max-width: 319px) {
            .sheet-content {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 320px) and (max-width: 339px) {
            .sheet-content {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 340px) and (max-width: 359px) {
            .sheet-content {
                transform: scale(calc(20% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 360px) and (max-width: 379px) {
            .sheet-content {
                transform: scale(calc(22% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 380px) and (max-width: 399px) {
            .sheet-content {
                transform: scale(calc(24% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 400px) and (max-width: 419px) {
            .sheet-content {
                transform: scale(calc(26% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 420px) and (max-width: 439px) {
            .sheet-content {
                transform: scale(calc(26% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 440px) and (max-width: 459px) {
            .sheet-content {
                transform: scale(calc(28% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 460px) and (max-width: 479px) {
            .sheet-content {
                transform: scale(calc(28.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 480px) and (max-width: 499px) {
            .sheet-content {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 500px) and (max-width: 519px) {
            .sheet-content {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 520px) and (max-width: 539px) {
            .sheet-content {
                transform: scale(calc(30% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 540px) and (max-width: 559px) {
            .sheet-content {
                transform: scale(calc(33.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 560px) and (max-width: 579px) {
            .sheet-content {
                transform: scale(calc(35% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 580px) and (max-width: 599px) {
            .sheet-content {
                transform: scale(calc(36% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 600px) and (max-width: 629px) {
            .sheet-content {
                transform: scale(calc(37.5% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 630px) and (max-width: 669px) {
            .sheet-content {
                transform: scale(calc(38.6% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 670px) and (max-width: 699px) {
            .sheet-content {
                transform: scale(calc(42% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 700px) and (max-width: 739px) {
            .sheet-content {
                transform: scale(calc(44% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 740px) and (max-width: 769px) {
            .sheet-content {
                transform: scale(calc(46% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (min-width: 770px) and (max-width: 799px) {
            .sheet-content {
                transform: scale(calc(48% * 2)) !important;
                transform-origin: 5px 0px;
            }
        }

        @media (max-width: 767px) {
            .sheet-content {
                margin: 0 auto;
            }
        }

        @media print {
            .sheet-content {
                transform: scale(1) !important;
            }
        }
      `}
    </style>

    <div className="A5 landscape">
      <div className="sheet-content">
        <section className="sheet padding-2mm">
          <div className="invoice-box">
            <div className="border_box">
              <table cellPadding="0" cellSpacing="0">
                <tbody>
                  <tr>
                    <td>
                      <table style={{ borderBottom: '1px solid #ccc' }}>
                        <tbody>
                          <tr>
                            <td style={{ width: '99px', padding: '0' }}></td>
                            <td style={{ 
                              borderRight: '1px solid #ccc',
                              borderLeft: '1px solid #ccc', 
                              padding: '0'
                            }}>
                              <div className="top_heading">
                                <span className="h1">
                                 {modifyForm?.address}
                                </span>
                                <p className="Address">HIG 1033, 6th Main Road, Moganppair Eri Scheme </p>
                                <p className="Address">Magappair West, Chennai- 600037 </p>
                                <p className="Address">M: +91 7566514634 | E : Newtransport@gmail.com | W: Newtransport.in</p>
                                <p className="Address">GST No. 3458783457 | FSSAI No. 345874857445 | PAN No. 43545454</p>
                              </div>
                            </td>
                            <td style={{ width: '99px', padding: '0' }}>
                              <div style={{ 
                                borderBottom: '1px solid #ccc', 
                                display: 'flex', 
                                padding: '5px', 
                                gap: '6px', 
                                alignItems: 'center'
                              }}>
                                <span style={{ 
                                  flexBasis: '35px', 
                                  fontSize: '10px',
                                  lineHeight: 'normal'
                                }}>LR No.</span>
                                <span style={{ lineHeight: 'normal' }}>540</span>
                              </div>
                              <div style={{ 
                                borderBottom: '1px solid #ccc', 
                                display: 'flex', 
                                padding: '5px', 
                                gap: '6px', 
                                alignItems: 'center'
                              }}>
                                <span style={{ 
                                  flexBasis: '35px', 
                                  fontSize: '10px',
                                  lineHeight: 'normal'
                                }}>TRIP</span>
                                <span style={{ lineHeight: 'normal' }}>540</span>
                              </div>
                              <div style={{ padding: '8px 6px' }}>
                                <div>MP20 GA 2109</div>
                                <div style={{ 
                                  fontSize: '9.4px', 
                                  lineHeight: 'normal'
                                }}>32 Feet MXL</div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <table style={{ borderBottom: '1px solid #ccc' }}>
                        <tbody>
                          <tr>
                            <td style={{ 
                              width: '50%',
                              borderRight: '1px solid #ccc', 
                              padding: '0'
                            }}>
                              <div style={{ 
                                padding: '6px 10px', 
                                display: 'flex', 
                                flexDirection: 'column', 
                                gap: '4px'
                              }}>
                                <div style={{ 
                                  display: 'flex', 
                                  fontSize: '10px', 
                                  gap: '6px'
                                }}>
                                  <span style={{ flexBasis: '70px' }}>Consignor</span> 
                                  <span style={{ flexBasis: 'calc(100% - 78px)' }}>PB09 | Parle Product Pvt. Ltd.</span>
                                </div>
                                <div style={{ 
                                  display: 'flex', 
                                  fontSize: '10px', 
                                  gap: '6px'
                                }}>
                                  <span style={{ flexBasis: '70px' }}>Pickup</span> 
                                  <span style={{ flexBasis: 'calc(100% - 78px)' }}>PB09 | Oriental Retailers & Logistics Pvt. LTD</span>
                                </div>
                                <div style={{ 
                                  display: 'flex', 
                                  fontSize: '10px', 
                                  gap: '6px'
                                }}>
                                  <span style={{ flexBasis: '70px' }}>Address</span> 
                                  <span style={{ flexBasis: 'calc(100% - 78px)' }}>HIG 1033, 6th Main Road, Moganppair Eri Scheme Magappair West, Chennai- 600037</span>
                                </div>
                                <div style={{ 
                                  display: 'flex', 
                                  fontSize: '10px', 
                                  gap: '6px'
                                }}>
                                  <span style={{ flexBasis: '70px' }}>GST Number</span> 
                                  <span style={{ flexBasis: 'calc(100% - 78px)' }}>GST Number</span>
                                </div>
                              </div>
                            </td>
                            <td style={{ 
                              width: '50%',
                              borderLeft: '1px solid #ccc', 
                              padding: '0'
                            }}>
                              <div style={{ 
                                padding: '6px 10px', 
                                display: 'flex', 
                                flexDirection: 'column', 
                                gap: '4px'
                              }}>
                                <div style={{ 
                                  display: 'flex', 
                                  fontSize: '10px', 
                                  gap: '6px'
                                }}>
                                  <span style={{ flexBasis: '70px' }}>Consignee</span> 
                                  <span style={{ flexBasis: 'calc(100% - 78px)' }}>PB09 | Parle Product Pvt. Ltd.</span>
                                </div>
                                <div style={{ 
                                  display: 'flex', 
                                  fontSize: '10px', 
                                  gap: '6px'
                                }}>
                                  <span style={{ flexBasis: '70px' }}>Contact</span> 
                                  <span style={{ flexBasis: 'calc(100% - 78px)' }}>234234234</span>
                                </div>
                                <div style={{ 
                                  display: 'flex', 
                                  fontSize: '10px', 
                                  gap: '6px'
                                }}>
                                  <span style={{ flexBasis: '70px' }}>Address</span> 
                                  <span style={{ flexBasis: 'calc(100% - 78px)' }}>HIG 1033, 6th Main Road, Moganppair Eri Scheme Magappair West, Chennai- 600037</span>
                                </div>
                                <div style={{ 
                                  display: 'flex', 
                                  fontSize: '10px', 
                                  gap: '6px'
                                }}>
                                  <span style={{ flexBasis: '70px' }}>GST Number</span> 
                                  <span style={{ flexBasis: 'calc(100% - 78px)' }}>GST Number</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <tr className="top">
                    <td colSpan="2">
                      <table cellPadding="0" cellSpacing="0">
                        <tbody>
                          <tr>
                            <td style={{ 
                              width: '165px', 
                              borderRight: '1px solid #ccc', 
                              padding: '0',
                              position: 'relative'
                            }}>
                              <div style={{ minHeight: '292px' }}>
                                <div style={{ 
                                  display: 'flex', 
                                  flexDirection: 'column', 
                                  justifyContent: 'space-between', 
                                  height: '100%', 
                                  position: 'absolute', 
                                  top: '0', 
                                  left: '0'
                                }}>
                                  <div style={{ padding: '10px 6px 6px 10px' }}>
                                    <div style={{ 
                                      display: 'flex',
                                      fontSize: '10px', 
                                      marginBottom: '5px'
                                    }}>
                                      <span>Driver Name</span>
                                      <span style={{ 
                                        flex: 'auto', 
                                        marginBottom: '3px', 
                                        borderBottom: '1px solid #C6C6C6'
                                      }}></span>
                                    </div>
                                    <div style={{ 
                                      display: 'flex',
                                      fontSize: '10px', 
                                      marginBottom: '5px'
                                    }}>
                                      <span>Driver Contact</span>
                                      <span style={{ 
                                        flex: 'auto', 
                                        marginBottom: '3px', 
                                        borderBottom: '1px solid #C6C6C6'
                                      }}></span>
                                    </div>
                                    <div style={{ 
                                      display: 'flex',
                                      fontSize: '10px', 
                                      marginBottom: '5px'
                                    }}>
                                      <span>License no.</span>
                                      <span style={{ 
                                        flex: 'auto', 
                                        marginBottom: '3px', 
                                        borderBottom: '1px solid #C6C6C6'
                                      }}></span>
                                    </div>
                                    <div style={{ 
                                      display: 'flex',
                                      fontSize: '10px', 
                                      marginBottom: '5px'
                                    }}>
                                      <span>PAN Number</span>
                                      <span style={{ 
                                        flex: 'auto', 
                                        marginBottom: '3px', 
                                        borderBottom: '1px solid #C6C6C6'
                                      }}></span>
                                    </div>
                                    <div style={{ 
                                      display: 'flex',
                                      fontSize: '10px', 
                                      marginBottom: '5px'
                                    }}>
                                      <span>Eway Bill No.</span>
                                      <span style={{ 
                                        flex: 'auto', 
                                        marginBottom: '3px', 
                                        borderBottom: '1px solid #C6C6C6'
                                      }}></span>
                                    </div>
                                    <div style={{ 
                                      display: 'flex',
                                      fontSize: '10px', 
                                      marginBottom: '5px'
                                    }}>
                                      <span>Invoice No.</span>
                                      <span style={{ 
                                        flex: 'auto', 
                                        marginBottom: '3px', 
                                        borderBottom: '1px solid #C6C6C6'
                                      }}></span>
                                    </div>
                                  </div>

                                  <div style={{ 
                                    borderTop: '1px solid #ccc', 
                                    padding: '4px 10px 6px 8px'
                                  }}>
                                    <div>
                                      <p style={{ 
                                        fontSize: '10px', 
                                        marginTop: '0', 
                                        marginBottom: '2px'
                                      }}>
                                        Terms & Conditions
                                      </p>
                                      <p style={{ 
                                        fontSize: '8.5px', 
                                        fontWeight: '500', 
                                        color: '#4A4A4A', 
                                        lineHeight: 'normal', 
                                        marginTop: '0', 
                                        marginBottom: '5px'
                                      }}>
                                      {` ${modifyForm?.terms_conds}`}
                                      </p>
                                      <p style={{ 
                                        fontSize: '8.5px', 
                                        fontWeight: '500', 
                                        color: '#4A4A4A', 
                                        lineHeight: 'normal', 
                                        marginTop: '0', 
                                        marginBottom: '0px'
                                      }}>
                                        गाड़ी खाली होने के 10 दिन तक (ACKNOWLEDGEMENT)
                                        (पहुँच) हमारे ऑफिस में जमा होनी चाहिए, अन्यथा
                                        बकाया (भाड़ा) नहीं दिया जाएगा
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>

                            <td style={{ 
                              width: 'calc(100% - 318px)', 
                              position: 'relative'
                            }}>
                              <div>
                                <table className="table_right" style={{ marginBottom: '65px' }}
                                  cellPadding="0" cellSpacing="0">
                                  <thead>
                                    <tr>
                                      {visibleColumns.map((column, index) => (
                                        <td key={index} style={{ width: calculateColumnWidth() }}>
                                          <div style={{ 
                                            width: '100%',
                                            maxWidth: calculateColumnWidth(),
                                            minWidth: calculateColumnWidth()
                                          }}>
                                            <span style={{ 
                                              display: 'inline-block', 
                                              width: 'calc(100% - 1px)'
                                            }}>
                                              {column.name}
                                            </span>
                                            <span className="__vrLine"></span>
                                          </div>
                                        </td>
                                      ))}
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {sampleData.map((row, rowIndex) => (
                                      <tr key={rowIndex}>
                                        {visibleColumns.map((column, colIndex) => (
                                          <td key={colIndex} style={{ fontSize: '10px', padding: '4px' }}>
                                            {row[column.name] || '-'}
                                          </td>
                                        ))}
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <div style={{ 
                                  position: 'absolute', 
                                  bottom: '0', 
                                  left: '0', 
                                  width: '100%'
                                }}>
                                  <table className="table_right" cellPadding="0" cellSpacing="0">
                                    <tfoot style={{ height: '65px' }}>
                                      <tr>
                                        {visibleColumns.map((column, index) => (
                                          <td key={index} style={{ 
                                            borderBottom: '1px solid #ccc', 
                                            paddingBottom: '5px', 
                                            fontSize: '10px', 
                                            width: calculateColumnWidth()
                                          }}>
                                            {index === 0 ? 'Value________________________' : ''}
                                          </td>
                                        ))}
                                      </tr>
                                      <tr>
                                        <td style={{ 
                                          textAlign: 'right', 
                                          fontSize: '10px'
                                        }}>
                                          Total
                                        </td>
                                        {visibleColumns.slice(1).map((column, index) => (
                                          <td key={index} style={{ fontSize: '10px' }}></td>
                                        ))}
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            </td>

                            <td style={{ 
                              width: '152px',
                              padding: '0',
                              position: 'relative'
                            }}>
                              <div style={{ minHeight: '292px' }}>
                                <div style={{ 
                                  display: 'flex', 
                                  flexDirection: 'column', 
                                  justifyContent: 'space-between', 
                                  height: '100%', 
                                  position: 'absolute', 
                                  top: '0', 
                                  left: '0'
                                }}>
                                  <div>
                                    <div style={{ 
                                      fontSize: '10px',
                                      borderBottom: '1px solid #ccc', 
                                      padding: '6px 10px', 
                                      lineHeight: 'normal', 
                                      textAlign: 'center'
                                    }}>
                                      TO BE FILLED
                                    </div>
                                    <div style={{ 
                                      fontSize: '9px', 
                                      textAlign: 'center', 
                                      opacity: '.35', 
                                      padding: '6px 20px', 
                                      lineHeight: 'normal'
                                    }}>
                                      Please Acknowledge with Rubber Stamp & Signature
                                    </div>
                                  </div>

                                  <div>
                                    <div style={{ 
                                      height: '45px', 
                                      borderTop: '1px solid #ccc', 
                                      display: 'flex', 
                                      justifyContent: 'center', 
                                      alignItems: 'flex-end'
                                    }}>
                                      <span style={{ 
                                        fontSize: '10px', 
                                        lineHeight: 'normal',
                                        paddingBottom: '5px'
                                      }}>
                                        Signature of Driver/ Owner
                                      </span>
                                    </div>
                                    <div style={{ 
                                      height: '43px', 
                                      borderTop: '1px solid #ccc', 
                                      display: 'flex', 
                                      justifyContent: 'center', 
                                      alignItems: 'flex-end'
                                    }}>
                                      <span style={{ 
                                        fontSize: '10px', 
                                        lineHeight: 'normal',
                                        paddingBottom: '5px'
                                      }}>
                                        Signature of Staff
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    </div>
    </>
  );
};

export default Format3;